import Provider from './Provider.vue';
import FormatBold from './FormatBold.vue';
import FormatItalic from './FormatItalic.vue';
import FormatQuoteClose from './FormatQuoteClose.vue';
import LinkVariant from './LinkVariant.vue';
import FileImage from './FileImage.vue';
import Table from './Table.vue';
import FormatListNumbers from './FormatListNumbers.vue';
import FormatListBulleted from './FormatListBulleted.vue';
import FormatSize from './FormatSize.vue';
import FormatStrikethrough from './FormatStrikethrough.vue';
import StatusBar from './StatusBar.vue';
import NavigationBar from './NavigationBar.vue';
import SidePreview from './SidePreview.vue';
import Eye from './Eye.vue';
import FilePlus from './FilePlus.vue';
import FileMultiple from './FileMultiple.vue';
import FolderPlus from './FolderPlus.vue';
import Delete from './Delete.vue';
import Close from './Close.vue';
import Pen from './Pen.vue';
import Target from './Target.vue';
import HelpCircle from './HelpCircle.vue';
import Toc from './Toc.vue';
import SyncOff from './SyncOff.vue';
import Upload from './Upload.vue';
import Download from './Download.vue';
import CodeTags from './CodeTags.vue';
import Information from './Information.vue';
import Alert from './Alert.vue';
import Folder from './Folder.vue';
import ScrollSync from './ScrollSync.vue';
import Printer from './Printer.vue';
import Undo from './Undo.vue';
import Redo from './Redo.vue';
import ContentSave from './ContentSave.vue';
import FormatListChecks from './FormatListChecks.vue';
import CheckCircle from './CheckCircle.vue';
import DotsHorizontal from './DotsHorizontal.vue';
import Magnify from './Magnify.vue';

export function registerIcons(app) {
  app.component('icon-provider', Provider);
  app.component('icon-format-bold', FormatBold);
  app.component('icon-format-italic', FormatItalic);
  app.component('icon-format-quote-close', FormatQuoteClose);
  app.component('icon-link-variant', LinkVariant);
  app.component('icon-file-image', FileImage);
  app.component('icon-table', Table);
  app.component('icon-format-list-numbers', FormatListNumbers);
  app.component('icon-format-list-bulleted', FormatListBulleted);
  app.component('icon-format-size', FormatSize);
  app.component('icon-format-strikethrough', FormatStrikethrough);
  app.component('icon-status-bar', StatusBar);
  app.component('icon-navigation-bar', NavigationBar);
  app.component('icon-side-preview', SidePreview);
  app.component('icon-eye', Eye);
  app.component('icon-file-plus', FilePlus);
  app.component('icon-file-multiple', FileMultiple);
  app.component('icon-folder-plus', FolderPlus);
  app.component('icon-delete', Delete);
  app.component('icon-close', Close);
  app.component('icon-pen', Pen);
  app.component('icon-target', Target);
  app.component('icon-help-circle', HelpCircle);
  app.component('icon-toc', Toc);
  app.component('icon-sync-off', SyncOff);
  app.component('icon-upload', Upload);
  app.component('icon-download', Download);
  app.component('icon-code-tags', CodeTags);
  app.component('icon-information', Information);
  app.component('icon-alert', Alert);
  app.component('icon-folder', Folder);
  app.component('icon-scroll-sync', ScrollSync);
  app.component('icon-printer', Printer);
  app.component('icon-undo', Undo);
  app.component('icon-redo', Redo);
  app.component('icon-content-save', ContentSave);
  app.component('icon-format-list-checks', FormatListChecks);
  app.component('icon-check-circle', CheckCircle);
  app.component('icon-dots-horizontal', DotsHorizontal);
  app.component('icon-magnify', Magnify);
}
